export default __webpack_public_path__ + "static/media/icon-certifications.73f288f3.svg";